module.exports = __WEBPACK_EXTERNAL_MODULE_811__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 811
// module chunks = 19